(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name printCard
   * @description
   *
   */
  angular
    .module('neo.home.entitats.entitat.printCards', [
      'ui.router'
    ]);
}());
